import moment from 'moment';


// Format Date in a more readable format - (accepts Date or String) returns a String
export function formatDate(dateToFormat: string | Date, includeTime: boolean = false): string {
    if (includeTime){
        return moment(dateToFormat).format("DD/MM/YYYY HH:mm")
    }
    return moment(dateToFormat).format("DD/MM/YYYY");
}

export function formatCurrentDate(): string {
    return new Date().toISOString().split("T")[0];
}

export function formatCurrentDateTime(): string {
    return new Date().toISOString().substring(0, new Date().toISOString().length - 1)
}

